(function () {
    'use strict';

    angular.module('app.editableText.preview', [
        'app.editableText',
        'app.core'
    ]);
})();